import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { getRedirectUrl } from "../service/cas";
// import { open } from "../libs/common";
import _ from "lodash";
import store from "store";
export default {
  data() {
    return {
      downLoadUrl: "",
      modal: false,
      time: 5,
      interval: null,
      appId: "",
      checked: false
    };
  },
  computed: {
    // checked() {
    //   return store.get("appTips").includes(this.appId);
    // },
  },
  methods: {
    change(value) {
      const arr = store.get("appTips") || [];
      if (value) {
        arr.push(this.appId);
      } else {
        _.pull(arr, this.appId);
      }
      store.set("appTips", arr);
    },
    async open(appId, token) {
      const res = await getRedirectUrl(appId);
      if (res && res.data && res.data.retVal) {
        const {
          jwtToken,
          downLoadUrl
        } = res.data.retVal;
        this.downLoadUrl = downLoadUrl;
        location.href = `${appId}://?token=${token || jwtToken}`;
      }
    },
    async show(appId, token) {
      console.log("====================================");
      console.log(this.modal);
      console.log("====================================");
      this.appId = appId;
      const appTips = store.get("appTips");
      this.checked = _.includes(appTips, this.appId);
      this.open(appId, token);
      if (!_.includes(appTips, appId)) {
        this.modal = true;
        // this.time = 5;
        // this.interval = setInterval(() => {
        //   if (this.time == 0) {
        //     this.modal = false;
        //   } else {
        //     this.time -= 1;
        //   }
        // }, 1000);
      }
    }
  },
  watch: {
    modal(value) {
      if (!value) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }
};